import React from "react"

export default function Delivered() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11" fill="none">
         <path fillRule="evenodd" clipRule="evenodd" d="M10.7911 0L11.4158 0.622293L4.65564 10.0879L0 5.41221L1.03955 4.37666L4.65564 6.63929L10.7911 0Z" fill="#777777" />
      </svg>
   )
}
